(function () {
  // Toggle `body.shopify-chat-open` while the Shopify Inbox chat window is open,
  // so product-card swatches (which use z-index) can be pushed behind the chat
  // wrapper and never poke through it on mobile.
  var OPEN_CLASS = 'shopify-chat-open';
  var OPEN_MIN_HEIGHT = 200; // the closed bubble is small; the open window is tall
  var ro = null;
  var host = null;

  function chatHost() {
    return (
      document.querySelector('inbox-online-store-chat') ||
      document.querySelector('#shopify-chat') ||
      document.querySelector('iframe[src*="shopify-chat"]') ||
      document.querySelector('.shopify-chat-button')
    );
  }

  function isOpen(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    // An open chat window is both tall and reasonably wide; the launcher bubble is not.
    return r.height > OPEN_MIN_HEIGHT && r.width > 120;
  }

  function sync() {
    document.body.classList.toggle(OPEN_CLASS, isOpen(host));
  }

  function attach() {
    var el = chatHost();
    if (!el) {
      host = null;
      document.body.classList.remove(OPEN_CLASS);
      return;
    }
    if (el !== host) {
      host = el;
      if (ro) ro.disconnect();
      if (window.ResizeObserver) {
        ro = new ResizeObserver(sync);
        ro.observe(host);
      }
    }
    sync();
  }

  // Light watcher: the chat is injected asynchronously by Shopify, and the
  // interval doubles as a fallback where ResizeObserver can't reach.
  setInterval(attach, 500);
  if (document.readyState !== 'loading') {
    attach();
  } else {
    document.addEventListener('DOMContentLoaded', attach);
  }
  window.addEventListener('load', attach);
})();
